import { translations } from '../locales/pl';

export const translateHouseholdName = (name: string): string => {
  return translations.households[name as keyof typeof translations.households] || name;
};

export const t = (key: string): string => {
  const keys = key.split('.');
  let value: any = translations;

  for (const k of keys) {
    value = value?.[k];
    if (value === undefined) {
      return key;
    }
  }

  return value || key;
};